/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OnlineAssetService {
    /**
     * Serve action offer flyer image.
     * Serve the first page of an upcoming main flyer from Storyblok assets.
     * @returns binary Success
     * @throws ApiError
     */
    public static getOnlineAssetImage({
        slug,
    }: {
        slug: string,
    }): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/whatsapp-image/{slug}.jpg',
            path: {
                'slug': slug,
            },
            errors: {
                400: `Validation error.`,
                404: `An error occurred.`,
            },
        });
    }
}
